import { post, get, upload } from '../../config/$ajax.js'
import { getErpHost,getErpLogHost } from '@/utils/domainHelper.js';
import {fxgDataMap} from '@/servers/prod/center/fxg.js'
import {_formatGoodsItem as ksDataMap} from '@/servers/prod/center/kuaishou.js'
import {pddDataMap} from '@/servers/prod/center/pdd.js'
import {_formatGoodsItem as alibabaDataMap} from '@/servers/prod/center/alibaba.js'
import {_formatGoodsItem as wxhDataMap} from '@/servers/prod/center/wxh.js'
import {_formatGoodsItem as xhsDataMap} from '@/servers/prod/center/xhs.js'
import {_formatGoodsItem as tbDataMap} from '@/servers/prod/center/tb.js'
import {_formatGoodsItem as tmDataMap} from '@/servers/prod/center/tm.js'
import {_formatGoodsItem as jdDataMap} from '@/servers/prod/center/jd.js'
import { _formatGoodsItem as taoteDataMap} from '@/servers/prod/center/tjb.js'
import {  _formatGoodsItem as yzDataMap} from '@/servers/prod/center/yz.js'
import { shopGoodsGetItemDetail } from './index.js'

import Vue from 'vue';
const API_HOST = getErpHost();

export const getAjax = (url, data = {}, params = {}) => {
  return get(API_HOST + url, data, params);
};

export const postAjax = (url, data = {}, params = {}) => {
  return post(API_HOST + url, data, params);
};

// 平台商品列表查询
export const queryList = function(data) {
  return postAjax('item/shopItem/platform/queryList', data)
}
// 平台商品总数查询
export const queryListCount = function(data) {
  return postAjax('item/shopItem/platform/count', data, { isNeedLoading:false })
}
export const batchQueryListCount = function(data) {
  return postAjax('item/shopItem/platform/batch/count', data,{appJson: true, submitType: 'json'})
}
// 获取列配置
export const columnConfig = function(data) {
  return getAjax('item/shopItem/columnConfig/queryList', data)
}
// 更新列配置
export const updateColumnConfig = function(data) {
  return postAjax('item/shopItem/columnConfig/update', data,{appJson: true, submitType: 'json'})
}
// 列配置恢复默认
export const updateToDefault = function(data) {
  return postAjax('item/shopItem/columnConfig/updateToDefault', data)
}
// 查询erp商品标签
export const getErpItemLabel = (data) => {
  return getAjax('item/tags/pages', data)
}
// 查询erp商品标签
export const addErpItemLabel = (data) => {
  return postAjax('item/tags/add', data)
}
// 设置批量标签
export const batchUpdateItemTag = (data) => {
  return postAjax('item/shopItem/platform/batchUpdateItemTag', data,{appJson: true, submitType: 'json'})
}
// 平台商品批量更新价格
export const batchUpdatePrice = function(data) {
  return postAjax('item/shopItem/platform/batchUpdatePrice', data, {appJson: true, submitType: 'json'})
}
// 平台商品批量更新标题
export const batchUpdateTitle = function(data) {
  return postAjax('item/shopItem/platform/batchUpdateTitle', data, {appJson: true, submitType: 'json'})
}
// 平台商品批量更新主图
export const batchUpdatePic = function(data) {
  return postAjax('item/shopItem/platform/batchUpdatePic', data, {appJson: true, submitType: 'json'})
}
// 批量更新上架状态
export const batchUpdateOnSale = function(data) {
  return postAjax('item/shopItem/platform/batchUpdateOnSale', data, {appJson: true, submitType: 'json'})
}
// 同步店铺数据
export const downSyncShopData = function(data) {
  return postAjax('item/shopItem/down/sync', data, {appJson: true, submitType: 'json'})
}
// 店铺同步时间
export const userImportsImports = function(data) {
  return getAjax('item/shopItem/user/imports/latest', data, {appJson: true})
}
// 同步店铺数据进度
export const downSyncShopDataCount = function(data) {
  return getAjax('item/sync/count', data, {appJson: true,isNeedLoading:false})
}
// 校验平台商品状态
export const checkItemStatus = function(data) {
  return postAjax('item/shopItem/platform/checkItemStatus', data, {appJson: true,submitType: 'json'})
}
export const checkMultiPlatformItemStatus = function(data) {
  return postAjax('item/shopItem/platform/checkMultiPlatformItemStatus', data, {appJson: true,submitType: 'json'})
}
// 批量删除平台商品
export const deleteItem = function(data) {
  return postAjax('item/shopItem/platform/delete', data, {appJson: true,submitType: 'json'})
}
// 平台商品导出Excel
export const exportPlatformItem = function(data) {
  return postAjax('item/shopItem/platform/export/item', data, {appJson: true, submitType: 'json'})
}
// 批量操作进度接口
export const getProgress = function(data) {
  return postAjax('items/progress/getProgress', data,{isNeedLoading:false})
}
// 批量修改发货时效
export const batchUpdateDeliveryTime = function (data) {
  return postAjax('item/shopItem/platform/batchUpdateDeliveryTime', data, { appJson: true, submitType: 'json' })
}
export const queryDemandTimeByEnv = function (data) {
  return getAjax('item/shopItem/platform/queryDemandTimeByEnv', data, { appJson: true, submitType: 'json' })
}
// 批量开启/关闭同步库存
export const batchUpdateSyncStock = function (data) {
  return postAjax('item/shopItem/platform/batchUpdateSyncStock', data, { appJson: true, submitType: 'json' })
}
// 更新平台库存
export const uploadPlatformStock = function (data) {
  return postAjax('item/shopItem/platform/uploadStock', data, { appJson: true, submitType: 'json', isNeedFailNotice: true })
}
// 批量更新平台库存
export const batchUploadPlatformStock = function (data) {
  return postAjax('item/shopItem/platform/batchUploadStock', data, { appJson: true, submitType: 'json', isNeedFailNotice: true })
}
// 获取平台库存更新进度
export const getUploadPlatformStockProgress = function (data) {
  return getAjax('stock/upload/manual/progress', data, { isNeedLoading: false })
}
// 查询店铺商品销量配置
export const getSaleCalcConfig = function(data) {
  return getAjax('item/shopItem/config/getSaleCalcConfig', data,{isNeedLoading:false})
}
// 更新店铺商品销量配置
export const updateSaleCalcConfig = function(data) {
  return postAjax('item/shopItem/config/updateSaleCalcConfig', data,{isNeedLoading:false})
}
// 查询日志列表
export const queryLogsList = function(data) {
  let url = getErpLogHost();
   return post(url+'trace/item/shopItem/list', data, {});
  // return postAjax('trace/item/shopItem/list', data)
}
// 获取商品详情
export const getShopGoodsItemDetail = function(data, config = {}){
    let dataMap = {
      'tb':tbDataMap,
      'tm':tmDataMap,
      'fxg':fxgDataMap,
      'jd':jdDataMap,
      'kuaishou':ksDataMap,
      'pdd':pddDataMap,
      '1688':alibabaDataMap,
      'wxsph':wxhDataMap,
      'xhs':xhsDataMap,
      'yz':yzDataMap,
    }
    if(!dataMap[data.platform]){
      Vue.prototype.$message.error(data.platform+':暂不支持该平台');
      return null
    }
    return shopGoodsGetItemDetail(data, config).then(res => {
      if (res.result === 1) {
        return dataMap[data.platform](res.data)
      }
      return null;
    })
}
/*抖店补库存相关接口start*/
//获取抖音平台库存策略
export const dyReplenishStock = function (data) {
  return postAjax('item/shopItem/platform/douyin/replenishStock', data, { appJson: true, submitType: 'json' })
}
// 商品列表包含sku的树型结构
export const dyQueryTree = function (data) {
  return postAjax('item/shopItem/platform/queryTree', data, { appJson: true, submitType: 'json' })
}
// 商品列表总数统计
export const dyQueryTreeCount = function (data) {
  return postAjax('item/shopItem/platform/queryTree/count', data, { appJson: true, submitType: 'json' })
}
// 获取当前商品下的所有sku
export const dyQueryTreeSkuMore = function (data) {
  return postAjax('item/shopItem/platform/queryTree/skuMore', data, { appJson: true, submitType: 'json' })
}
// 执行修改库存、发货时效
export const batchSaveDouyinReplenishStockAndDeliveryTime = function (data) {
  return postAjax('item/shopItem/platform/batchSaveDouyinReplenishStockAndDeliveryTime', data, { appJson: true, submitType: 'json' })
}
/*抖店补库存相关接口end*/

export const getFastPublishBaseItemId = function (data) {
  return post('/shop/goods/getFastPublishBaseItemId', data, { appJson: true, submitType: 'json' })
}
export const getPredictionCat = function (data) {
  return post('/shop/goods/prediction/cat', data, { appJson: true, submitType: 'json' })
}
// 自动生成平台编码并上传平台
export const generatePlatformCodeUpload = function (data) {
  return postAjax('item/shopItem/platform/code/generate/item/upload', data, { appJson: true, submitType: 'json' })
}
// 普通生成平台编码（不上传）
export const generateNormalPlatformCode = function (data) {
  return postAjax('item/shopItem/platform/code/generate/normal/item', data, { appJson: true, submitType: 'json' })
}
// 保存生成的编码（不上传）
export const saveGeneratedPlatformCode = function (data) {
  return postAjax('item/shopItem/platform/code/generate/item/save', data, { appJson: true, submitType: 'json' })
}
